import { render, staticRenderFns } from "./UserResume.vue?vue&type=template&id=5c1cb3d2&"
import script from "./UserResume.vue?vue&type=script&lang=js&"
export * from "./UserResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports